<template>
  <v-app>
    <not-auth-toolbar can-go-back>
      <v-toolbar-title slot="title">
        <span>个人中心</span>
        <span class="mx-2">|</span>
        <span class="font-weight-light primary--text">{{self.name || self.loginId}}</span>
      </v-toolbar-title>
    </not-auth-toolbar>
    <v-content>
      <l-fixed-window :to-bottom="36">
        <l-layout :layout="['xs12', 'lg10']">
          <v-layout>
            <personal-card :person="self"></personal-card>
          </v-layout>
          <v-layout class="py-2">
            <v-flex class="text-xs-right">
              <v-btn :loading="logoutLoading" @click="logout" class="mx-0" color="primary">退出登录</v-btn>
            </v-flex>
          </v-layout>
        </l-layout>
      </l-fixed-window>
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>

import NotAuthToolbar from '../APP/Toolbar/notAuthToolbar'
import AppFooter from '../APP/Footer/appFooter'
import PersonalCard from './personalCard'

let LOGIN_PAGE_NAME = 'Login'
export default {
  name: 'personalCenter',
  components: {PersonalCard, AppFooter, NotAuthToolbar},
  data: () => ({
    logoutLoading: false,
  }),
  computed: {
    self () {
      return this.$store.state.login.self || {}
    }
  },
  methods: {
    changeInstitution () {
      this.$L.cfg.appName.subTitle = '西南交通大学'
    },
    async logout () {
      this.logoutLoading = true
      try {
        await this.$store.dispatch('login/logout')
        this.value_ = false
        this.$router.push({name: LOGIN_PAGE_NAME})
      }
      catch (e) {
        this.$store.dispatch('alert', {type: 'error', title: '登出时发生错误', message: e.message})
      }
      finally {
        this.logoutLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
